import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { DeleteButton } from '../../../components/DeleteButton';
import { CopyButton } from '../../../components/CopyButton';
import { EditButton } from '../../../components/EditButton';
import * as Utils from '../../../utils/helper';

import css from './DeviceEntry.module.scss';

export const DeviceEntry = ({ tenant, device, handleDelete, handleEdit }) => {

    const getLabelWithMaxLength = (label, maxLenght) => {
        if (!label) {
            return null;
        }

        if (label.length <= maxLenght) {
            return <>{label}</>
        }

        const labelTrimmed = label.substring(0, maxLenght - 2).trim() + "...";

        return <>
            <OverlayTrigger 
                placement='right'
                overlay={
                    <Tooltip>
                        {label}
                    </Tooltip>
                }
            >
                <span>{labelTrimmed}</span>
            </OverlayTrigger>
        </>;
    }
       
    return (
        <tr>
            <td>
                <div className={css.flexContainer}>
                    <div>
                        {device.deviceName}
                    </div>
                </div>
            </td>
            <td>
                <div className={css.flexContainer}>
                    <div>
                        {getLabelWithMaxLength(device.deviceDescription, 100)}
                    </div>
                </div>
            </td>
            <td>
                <div className="d-flex align-items-center justify-content-between">
                    <span>{device.sipUsername}</span>
                    <CopyButton
                        className="float-end"
                        tooltip="Copy username"
                        onClick={() => navigator.clipboard.writeText(device.sipUsername)}
                    />
                </div>
            </td>
            <td>
                <div className="d-flex align-items-center justify-content-between">
                    <span>{device.sipPassword.substring(0, 3)} ●●●●●●●●●●</span>
                    <CopyButton
                        className="float-end"
                        tooltip="Copy password"
                        onClick={() => navigator.clipboard.writeText(device.sipPassword)}
                    />
                </div>
            </td>
            <td className="align-middle">
                {Utils.isTrue(device.enabled) ? "yes" : "no"}
            </td>
            <td className="align-left">
                {device.groupName}
            </td>
            <td className="align-middle">
                <DeleteButton className="float-right mr-1" placement="top" tooltip="Delete" onClick={() => handleDelete(device)} />
                <EditButton className="float-right mr-1" placement="top" tooltip="Edit" onClick={() => handleEdit(device)} />                
            </td>
        </tr>
    )
}